// @flow

import { Component, type Node } from "react";
import { createPortal } from "react-dom";

type Props = {
  children: Node,
};

export default class Portal extends Component<Props> {
  domElement: HTMLDivElement = document.createElement("div");

  componentDidMount() {
    document.body && document.body.appendChild(this.domElement);
  }

  componentWillUnmount() {
    document.body && document.body.removeChild(this.domElement);
  }

  render() {
    const { children } = this.props;

    return createPortal(children, this.domElement);
  }
}
